export const isRouteActive = (link, path) => {
  if (!link || link === '/' || link === '/#') return false;
  const getSegments = p => String(p).split('/').filter(Boolean);
  const linkSegments = getSegments(link);
  const pathSegments = getSegments(path);
  if (!linkSegments.length) return false;

  const depth = linkSegments[0] === 'crude' ? 2 : 1;
  return (
    linkSegments.slice(0, depth).join('/') ===
    pathSegments.slice(0, depth).join('/')
  );
};
